export const BASE_PATH_PREFIX = "/";

export const LOGIN_PATH = "/login";
export const FORGOT_PASSWORD_PATH = "/forgot-password";
export const RESET_PASSWORD_PATH = "/reset-password";
export const OKTA_CALLBACK_PATH = "/login/callback";
export const SAML_CALLBACK_PATH = "/saml/callback";
export const GOOGLE_CALLBACK_PATH = "/login/google/callback";
export const NOACCESS = "/no-access";
export const UNAUTHORIZED = "/unauthorized";
export const NOT_CONNECTED = "/not-connected";
export const NOT_FOUND_PATH = "/not-found";
export const NOT_FOUND = "*";
// Not a React route: the user manual is a separate static site deployed under
// this path of the same Static Web App (see public/staticwebapp.config.json).
export const USER_MANUAL_PATH = "/user-manual/";
// The mobile app's user guide: a different site (the mobile app's own origin),
// so a full URL from public/config.js, per environment. On localhost the
// `local` entry wins. Empty when not configured.
const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
const mobileGuideEnvironment = isLocalhost ? "local" : window.configuration?.ENVIRONMENT || "dev";
export const MOBILE_USER_GUIDE_URL =
  window.configuration?.MOBILE_USER_GUIDE_URL?.[mobileGuideEnvironment] || "";
// The manual's shared-calendar page: the only manual content a sharable link's
// recipient sees, and it opens without a login.
export const USER_MANUAL_SHARED_CALENDAR_PATH = `${USER_MANUAL_PATH}shared-calendar/scheduling-calendar`;

export const TENANT_MANAGEMENT = "/tenant-management";
export const TENANT_DETAILS = `${TENANT_MANAGEMENT}/tenant-details/:id`;
export const TENANT_HIERARCHY_CONFIGURATION = "/tenant-hierarchy-configuration";
export const MASTER_TIMEZONE_MANAGEMENT = "/master-timezone-management";

export const LIVE_AVAILABLE_SHIFTS = "/live-available-shifts";

export const RAD_PATH = "/providers";
export const SITE_PATH = "/facilities";
export const ADMIN_PATH = "/admin";

export const HIERARCHY_MANAGEMENT = `${ADMIN_PATH}/hierarchy-management`;
export const DEMAND_MANAGEMENT = `${ADMIN_PATH}/demand-management`;
export const SCHEDULING = `${ADMIN_PATH}/scheduling`;
export const DROPDOWN_MANAGEMENT = `${ADMIN_PATH}/dropdown-management`;
export const COLOR_MANAGEMENT = `${ADMIN_PATH}/color-management`;

export const ADMIN_PROVIDER_DROPDOWNS_PATH = `${DROPDOWN_MANAGEMENT}/providers-dropdowns`;
export const ADMIN_FACILITY_DROPDOWNS_PATH = `${DROPDOWN_MANAGEMENT}/facility-dropdowns`;
export const ADMIN_LEADERSHIP_DROPDOWNS_PATH = `${DROPDOWN_MANAGEMENT}/leadership-dropdowns`;

export const EXAM_PATH = "/exam";
export const REPORT_PATH = "/reports";
export const STRATEGIC_FORECAST_PATH = "/strategic-forecast";
export const SCHEDULE_PATH = "/schedules";

export const SCHEDULING_CALENDAR = `${SCHEDULE_PATH}/scheduling`;
export const PROVIDER_REQUEST = `${SCHEDULE_PATH}/provider-request`;
export const SCHEDULING_CALENDAR_SHARE_LINKS = `${SCHEDULE_PATH}/share-links`;

export const VOLUME_TREND_REPORT = "/volume-trend-report";
export const DEMAND_TABLE = "/demand-table";
export const CAPSvsDEMANDTABLE = "/CapacityVsDemandReports";

export const FORECAST = "/demandForecast/forecasting";
export const FORECASTREPORT = "/demandForecast/report";
export const FORECAST_OPTIMIZE = "/demandForecast/optimize";
export const FORECAST_CAPSVSDEMAND = "/demandForecast/capsvsdemand";

// New Forecast 2.0 routes
// export const FORECAST2 = '/demandForecast/forecasting2';
export const FORECASTREPORT2 = "/demandForecast/report2";

export const OPTIMIZE = "/optimize";
export const SCHEDULE = "/scheduling";

export const FORECAST_PATH = "/forecasting";
export const FORECASTING_FORECAST = `${FORECAST_PATH}/forecast`;
export const GENERATE_FORECAST = `${FORECAST_PATH}/generateForecast`;
export const FORECASTING_OPTIMIZE = `${FORECAST_PATH}/optimize`;
export const DEMAND_FORECAST = `${FORECAST_PATH}/demandForecast`;
export const FORECASTING_SCHEDULES = `${FORECAST_PATH}/schedules`;
export const CAPACITY_FORECAST = `${FORECAST_PATH}/capacityForecast`;

export const RAD_LIST = `${RAD_PATH}/list`;
export const UNASSIGNED_PROVIDER_LIST = `${RAD_PATH}/unassigned-providers`;
export const STATE_LICENSE = `${RAD_PATH}/state-license`;
export const LICENSE_PRIVILEGE_POWER_SYNC = `${RAD_PATH}/license-privileges-power-sync`;
export const CAPACITY_INPUT = `${RAD_PATH}/capacity-input`;
export const CAPACITY_INPUT_NEW = `${RAD_PATH}/capacity`;
export const CUSTOM_VIEW = `${RAD_PATH}/custom-view`;
export const RAD_CUSTOM_VIEW = `${RAD_PATH}/ProviderCustomView`;
export const CONFIG_CUSTOM_VIEW = `${CUSTOM_VIEW}/config-custom-view`;
export const CONFIG_CUSTOM_VIEW_EDIT = `${CUSTOM_VIEW}/config-custom-view/:id`;
export const RAD_LEADERSHIP_BULK_UPDATE = `${RAD_PATH}/leadership-bulk-update`;
export const RAD_HOURLY_VOLUME_SHARE = `${RAD_PATH}/hourly-volume-share`;
export const ANNUAL_HOUR_TRACKER = `${RAD_PATH}/annual-hour-tracker`;
export const AUDIT_LOGS = `${RAD_PATH}/audit-logs`;
export const RAD_PROFILE = `${RAD_PATH}/providerProfile`;
export const EDIT_RAD_PROFILE = `${RAD_PATH}/edit-provider-profile`;

export const REGIONALPRACTICEWORKLIST = `${ADMIN_PATH}/regional-practice-worklist`;
export const NATIONAL = `${HIERARCHY_MANAGEMENT}/national`;
export const REGION = `${HIERARCHY_MANAGEMENT}/region`;
export const REGIONALPRACTICE = `${ADMIN_PATH}/regional-practice`;
export const RPCE = `${ADMIN_PATH}/rpce`;
export const WORKLIST = `${ADMIN_PATH}/worklist`;
export const WORKLIST_DEFINITION = `${DEMAND_MANAGEMENT}/worklist-definition`;
export const WORKLIST_DEFINITION_CONFIGURATION = `${DEMAND_MANAGEMENT}/worklist-definition/configuration`;
export const WORKLIST_GROUP = `${DEMAND_MANAGEMENT}/worklist-group`;
export const TAG_CATEGORY_CONFIGURATION = `${ADMIN_PATH}/tag-management`;
export const SUBPRACTICE = `${HIERARCHY_MANAGEMENT}/subpractice`;
export const PRACTICE = `${HIERARCHY_MANAGEMENT}/practice`;
export const SECTIONWORKLIST = `${DEMAND_MANAGEMENT}/section-worklist-mapping`;
export const USERMANAGEMENT = `${ADMIN_PATH}/user-management`;
export const HOLIDAYPLANNER = `${ADMIN_PATH}/holiday-planner`;
export const HOLIDAYDEMANDPLANNER = `${ADMIN_PATH}/holiday-demand-planner`;
export const MAIN_PRACTICE = `${ADMIN_PATH}/main-practice`;
export const RAD_TYPE = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/provider-type`;
export const RAD_STATUS = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/provider-status`;
export const PROVIDER_DOCUMENT_TYPE = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/document-category`;
export const PROVIDER_NOTE_TYPE = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/note-category`;
export const RAD_COMMUNICATION_TYPE = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/provider-communication-type`;
export const SCHEDULETYPE = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/schedule-type`;
export const SUBSPECIALITY = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/subspeciality`;
export const BILLING_MANAGEMENT = `${ADMIN_FACILITY_DROPDOWNS_PATH}/billing-management`;
export const WEEK_ROTATION = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/week-rotation`;
export const WEEK_ROTATION_TEMPLATE = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/week-rotation-template`;
export const PARTNERSHIP_RATE = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/partnership-rate`;
export const PARTNERSHIP_STATUS = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/partnership-status`;
export const PARTNERSHIP_TIME = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/time-to-partnership`;
export const RAD_DEGREE = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/provider-title`;
export const DESIGNATION = `${ADMIN_LEADERSHIP_DROPDOWNS_PATH}/user-designations`;
export const COMMITTEES = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/committees`;
export const FUTURE_SECTION_CHANGE = `${ADMIN_FACILITY_DROPDOWNS_PATH}/future-section-change`;
export const RVURATE = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/rvu-rate`;
export const TIMEZONE_MANAGEMENT = `${DROPDOWN_MANAGEMENT}/time-zone`;
export const REQUEST_STATUS = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/request-status`;
export const TRAUMA_FACILITY_LEVEL = `${ADMIN_FACILITY_DROPDOWNS_PATH}/trauma-facility-level`;
export const QGENDA_SECTION = `${ADMIN_FACILITY_DROPDOWNS_PATH}/encore-section`;
export const SITE_STATUS = `${ADMIN_FACILITY_DROPDOWNS_PATH}/facility-status`;
export const MODALITY = `${DROPDOWN_MANAGEMENT}/modality`;
export const PRIORITY = `${ADMIN_FACILITY_DROPDOWNS_PATH}/priority`;
export const STAFF_CATEGORY = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/provider-category`;
export const STAFF_PRIMARY_LOCATION = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/staff-primary-location`;
export const SPECIALTY_CASES = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/specialty-cases`;
export const STAFFING_AGENCY = `${ADMIN_PROVIDER_DROPDOWNS_PATH}/staffing-agency-entity`;
export const SITECOVERAGEMATRIX = `${DEMAND_MANAGEMENT}/facility-coverage-matrix`;
export const COVERAGE_GAP = `${COLOR_MANAGEMENT}/coverage-gap-color-config`;
export const PRIORITYSLAMAPPING = `${DEMAND_MANAGEMENT}/priority-mapping`;
export const SHIFT_HOUR_CONFIGURATION = `${SCHEDULING}/shift-hour-configuration`;
export const DLS_CONFIGURATION = `${DEMAND_MANAGEMENT}/DLS-configuration`;
export const BLOCK_PLANNING = `${ADMIN_PATH}${COLOR_MANAGEMENT}/block-planning-color-config`;
export const DAY_OF_WEEK_CONFIGURATION = `${SCHEDULING}/day-of-week-configuration`;
export const TASK_CONFIGURATION = `${SCHEDULING}/task-configuration`;
export const TASK_CONFIGURATION_PANEL = `${TASK_CONFIGURATION}/panel`;
export const TASK_CONFIGURATION_PANEL_BASE = `${TASK_CONFIGURATION_PANEL}/:taskId`;
export const TASK_CONFIGURATION_PANEL_GENERAL = `${TASK_CONFIGURATION_PANEL}/:taskId/general`;
export const TASK_CONFIGURATION_PANEL_TASK_TAGS = `${TASK_CONFIGURATION_PANEL}/:taskId/task-tags`;
export const TASK_CONFIGURATION_PANEL_PROVIDER_POOL = `${TASK_CONFIGURATION_PANEL}/:taskId/provider-pool`;
export const TASK_CONFIGURATION_PANEL_COMPENSATION = `${TASK_CONFIGURATION_PANEL}/:taskId/compensation`;
export const PROVIDER_TASK_POOL = `${TASK_CONFIGURATION}/provider-pool`;
export const SIMULATOR_COLOR_CONFIGURATION = `${COLOR_MANAGEMENT}/simulator-color-config`;
export const LICENSE_PRIVILEGE_STATUS_MAPPING = `${ADMIN_PATH}/license-privilege-status-mapping`;
export const LICENSE_MAPPING = `${LICENSE_PRIVILEGE_STATUS_MAPPING}/license-mapping`;
export const PRIVILEGES_MAPPING = `${LICENSE_PRIVILEGE_STATUS_MAPPING}/privileges-mapping`;
export const READING_STATUS_MAPPING = `${LICENSE_PRIVILEGE_STATUS_MAPPING}/reading-status-mapping`;
export const DEFINE_MISMATCH = `${LICENSE_PRIVILEGE_STATUS_MAPPING}/define-mismatch`;
export const EMAIL_NOTIFICATION = `${ADMIN_PATH}/email-notification`;

export const RAW_EXAM_DATA = `${EXAM_PATH}/raw-exam-data`;
export const EXAM_DATA = `${EXAM_PATH}/exam-data`;
export const UNREAD = `${EXAM_PATH}/unread`;
export const TAT_DATA = `${EXAM_PATH}/TAT`;
export const EXAM_DATA_READ = `${EXAM_PATH}/readdata`;
export const MISCELLANEOUS_SITE_DATA = `${EXAM_PATH}/miscellaneous-facility-data`;
export const EXAM_METRICS = `${EXAM_PATH}/exam-metrics`;

export const SITE_LIST = `${SITE_PATH}/list`;
export const SITE_CUSTOM_VIEW = `${SITE_PATH}/custom-view`;
export const SITE_FACILITY_CUSTOM_VIEW = `${SITE_PATH}/facility-custom-view`;
export const UNASSIGNED_SITES = `${SITE_PATH}/unassigned-facilities`;
export const SITEALIASMANAGEMENT_SITE = `${SITE_PATH}/facility-alias-management`;
export const SITE_HOURLY_VOLUME_SHARE = `${SITE_PATH}/hourly-volume-share`;
export const SITE_PROFILE = `${SITE_PATH}/facilityprofile`;
export const EDIT_SITE_PROFILE = `${SITE_PATH}/edit-facility-profile`;
export const SITE_CONFIG_CUSTOM_VIEW = `${SITE_PATH}/custom-view/config-custom-view`;
export const SITE_CONFIG_CUSTOM_VIEW_EDIT = `${SITE_PATH}/custom-view/config-custom-view/:id`;

export const REPORT_CONFIGURATION = `${REPORT_PATH}/report-configuration`;
export const MATRIX_DAILY_REPORT = `${REPORT_PATH}/matrix-daily-report`;
export const PERFORMANCE_DASHBOARD = `${REPORT_PATH}/performance-dashboard`;
export const COVERAGE_GAP_TOOL = `${REPORT_PATH}/coverage-gap-tool-old`;
export const HOLIDAY_GAP_TOOL = `${REPORT_PATH}/holiday-gap-tool`;
export const PRIVILEGE_POWER_SYNC = `${REPORT_PATH}/privilege-power-sync`;
export const DAILY_REPORT = `${REPORT_PATH}/daily-report`;
export const MARKET_VOLUME_SHARE = `${REPORT_PATH}/market-volume-share`;
export const COVERAGE_GAP_TOOL_ENCORE = `${REPORT_PATH}/coverage-gap-tool`;
export const PERFORMANCE_DASHBOARD_COMBINED = `${REPORT_PATH}/performance-dashboard-combined`;
export const MATRIX_SERVICE_REQUEST = `${STRATEGIC_FORECAST_PATH}/matrix-service-request`;
export const STRATEGIC_DEMAND_PLANNER = `${STRATEGIC_FORECAST_PATH}/strategic-demand-planner`;
export const STRATEGIC_CAPACITY_PLANNER = `${STRATEGIC_FORECAST_PATH}/strategic-capacity-planner`;
export const STRATEGIC_CAPS_VS_DEMAND_PLANNER = `${STRATEGIC_FORECAST_PATH}/strategic-caps-vs-demand-planner`;

export const CAPACITY_TABLE = "/capacity-table";
export const CAPS_VS_DEMAND_TABLE = "/capacity-vs-demand-table";

export const SCHEDULE_SHARE_LINKS = "/schedule/share-links";

export const PUBLIC_SCHEDULE = "/public/schedule";
export const PUBLIC_SCHEDULING_CALENDAR = "/public/scheduling-calendar";
export const PUBLIC_SCHEDULING_CALENDAR_VERIFY_PASSWORD = "/public/scheduling-calendar/verify-password";
